import ModalOptIn from './ModalOptIn';

export default ModalOptIn;
